import services from "@/services"

const state  = {
    items : [],
    data : {}
}

const getters = {
    buyerItems: state => state.items,
    buyerDetail: state => state.data
}

const mutations = {
    setBuyerItems: (state,items) => {
        state.items = items
    },
    setBuyerDetail: (state,data) => {
        state.data = data
    }
}

const actions = {
    getAll({ commit, dispatch }, param) {
        dispatch('setLoadingTable', true, { root: true })
        services.setHeader()
        return new Promise((resolve , reject) => {
            services.get('buyer',param).then((response) => {
                commit('setBuyerItems',response.data.data.items)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
                dispatch('setLoadingTable', false, { root: true })
            })
        })
    },
    getById({ commit, dispatch }, id) {
        services.setHeader()
        dispatch('setLoadingGlobal', true, { root: true })
        return new Promise((resolve , reject) => {
            services.get('buyer/'+id).then((response) => {
                commit('setBuyerDetail',response.data.data)
                resolve(response)
            }).catch((error) => {
                reject(error)
            }).finally(()=>{
                dispatch('setLoadingGlobal', false, { root: true })
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}